import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";

const keyInLocalStorage = "dark-mode";
export const isDarkMode = () => {
    let savedDarkMode = localStorage.getItem(keyInLocalStorage);
    if (savedDarkMode === "true") {
      return true;
    } else {
      return false;
    }
  }

const ToggleDarkMode = () => {
  const [darkMode, setDarkMode] = useState(false);
  //const [isVisible, setIsVisible] = useState(false);
  const me = useSelector(state => state.me);
  const isVisible = !!me?.settings?.showButtonDarkMode

  const changeDarkMode = () => {
    let link = document.getElementById("dark-mode-style");
    if (darkMode) {
      if (!link) {
        link = document.createElement("link");
        link.id = "dark-mode-style";
        link.rel = "stylesheet";
        link.href = "/css/dark-mode.css";
        document.head.appendChild(link);
        console.log("Experimental Dark Mode, please report any issues");
        console.log("Dark mode enable");
      }
    } else {
      if (link) {
        link.remove();
        console.log("Dark mode disable");
      }
    }
  }

  const getDarkMode = () => {
    setDarkMode(isDarkMode());

  }
  /* const showConfig = () => {
    let showConfigDarkMode = localStorage.getItem("showConfigDarkMode")
    showConfigDarkMode = showConfigDarkMode === "true"
    setIsVisible(showConfigDarkMode)
  } */

  const changeStatus = () => {
    setDarkMode(!darkMode);
    localStorage.setItem(keyInLocalStorage, !darkMode);
  }

  useEffect(() => {
    changeDarkMode();
    // eslint-disable-next-line
  }, [darkMode]);

  useEffect(() => {
    getDarkMode()
    //showConfig()
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{display: isVisible ? "block" : "none"}}>
      <Button circular icon={darkMode ? 'moon': 'sun' }onClick={() => changeStatus()} />
    </div>
  );
};

export default ToggleDarkMode;
